import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";

import { Flex } from "orcs-design-system";

import { useCheckReportingResourceProvisioned } from "src/contexts/global/WorkspaceContext/WorkspaceContext";
import AppSwitchLink from "./AppSwitchLink";
import shouldShowReportsLink from "./utils/reports.utils";

const InternalAppLinks = ({ user, workspace }) => {
  const isReportingInfraProvisioned = useCheckReportingResourceProvisioned();
  const reportsURL = get(workspace, "config.tenantConfig.reportsUrl");

  const showReportsLink = shouldShowReportsLink({
    workspace,
    isReportingInfraProvisioned,
    user,
  });

  return (
    <Flex flexDirection="column" gap="r">
      {showReportsLink && (
        <AppSwitchLink
          label="Reports"
          description="Reporting dashboard shows you all insights and numbers from your data"
          href={reportsURL}
          icon={["far", "chart-column"]}
        />
      )}
    </Flex>
  );
};

InternalAppLinks.propTypes = {
  user: PropTypes.object,
  workspace: PropTypes.object,
};

export default InternalAppLinks;
